export default "__VITE_ASSET__sDl8VCLh__"